// Поведение каркаса страниц (layout.html.twig): меню на телефоне, полоса бонусов над подвалом,
// окна reCAPTCHA и увеличение фото. Раньше это были встроенные скрипты layout на jQuery.
import { $ } from './lib/dollar';
import { installLightbox } from './lib/lightbox';

export function installLayout(doc = document) {
    const win = doc.defaultView;
    const each = (selector, fn) => Array.prototype.forEach.call(doc.querySelectorAll(selector), fn);
    const toggleMenu = open => {
        doc.body.classList.toggle('hiddenBody', open);
        each('.navigation', nav => nav.classList.toggle('nav_is-open', open));
        $('.navigation-mobile-actions').toggle();
    };

    each('.navigation__toggle', button => button.addEventListener('click', () => toggleMenu()));
    win.addEventListener('load', () => {
        // Пустой обработчик нужен iOS: без него нажатие на крестик не закрывает окно.
        each('.modal-mobile__close, .modal-mobile__close .container, .modal-mobile__close .container span',
            node => node.addEventListener('click', () => {}));
        each('.navigation__nav-mobile a, .navigation__menu li a', link => link.addEventListener('click', () => toggleMenu(false)));
    });

    // Полоса бонусов (шаблон корзины) стоит над подвалом, пока подвал виден.
    win.addEventListener('scroll', () => {
        const footer = $('.footer');
        if (!footer.length) return;
        const top = footer[0].getBoundingClientRect().top + win.pageYOffset - doc.documentElement.clientTop;
        const overFooter = win.pageYOffset + doc.documentElement.clientHeight > top;
        $('.bonus-line-wrapper').css(overFooter ? { position: 'absolute', bottom: footer.height() } : { position: 'fixed', bottom: 0 });
    });

    // reCAPTCHA вызывает эту функцию после загрузки (onload в адресе скрипта). Окна по id блока
    // нужны services.js: он сбрасывает окно оформления заказа.
    win.captchaWidget = {};
    win.grecaptchaCallback = () => {
        const inputs = { recaptcha: 'grecaptcha-input', 'recaptcha-2': 'grecaptcha-input-2' };
        Object.keys(inputs).forEach(id => {
            if (doc.getElementById(id)) {
                win.captchaWidget[id] = win.grecaptcha.render(id, { callback: response => { doc.getElementById(inputs[id]).value = response; } });
            }
        });
    };

    installLightbox(doc);
}
